import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const TwitterIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 21",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "currentColor",
    d: "M2.4,12.9c1-0.2,1.7-0.2,2.4,0v-0.8c-1.3,0.1-2.4-0.7-3.2-1.6c-0.4-1-0.7-1.9-0.8-3.2 C1.6,8,2.4,8.2,3.2,8.1C2.1,7.5,1.4,6.5,0.8,5.7c0-1.6,0.2-2.8,0.8-4C4.3,4.9,7.7,6.6,12,6.5c-0.4-1.3-0.2-2.4,0.8-3.2 c0.4-1.3,1.6-2.1,3.2-2.4c1.5-0.2,2.9,0.3,4,1.6c1.4-0.3,2.3-0.7,3.2-0.8V0.9c-0.2,1.5-1,2.4-1.6,3.2c0.6-0.3,1.5-0.5,2.4-0.8 c-0.2,0.2-0.4,0.4-0.8,0.8c-0.3,0.5-0.9,1-1.6,1.6c0,0.8,0,1.5,0,2.4c-0.3,1.3-0.8,2.8-1.6,4c-0.5,1.6-1.4,2.8-2.4,4 c-1.9,1.9-4.2,3.1-7.2,4c-0.6-0.1-1.5,0-2.4,0c-2.8,0.1-5.5-0.6-8-2.4c1.7,0.4,3.4,0.2,4.8-0.8c1,0,1.7-0.4,2.4-0.8 C4.7,15.8,3.1,14,2.4,12.9z"
  })));
};
TwitterIcon.displayName = 'TwitterIcon';
export default TwitterIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TwitterIcon.js.map